const Overlay = (function () {
    'use strict'

    let overlay;

    const init = () => {
        overlay = document.querySelector('[data-hook=overlay]');
    }

    const close = () => {
        overlay.removeAttribute('data-is-open');
        License.reset();
    }

    const open = () => {
        overlay.setAttribute('data-is-open', '');
    }

    return {
        init: init,
        close: close,
        open: open,
    }
})();
